import { Channel } from './channel';

export class Graph {
    id?: string;
    type: GraphType;
    title: string = '';
    vesselId: string;
    index?: number;
    graph?: ExhaustGraph | GaugeGraph | BarGraph;
}

export class ExhaustGraph {
    id?: string;
    graphId: string;
    CylinderChannels: ExhaustChannel[];
    TurboChannels?: Turbocharger[];
    averageChannel?: Channel;
    averageChannelData?: Channel;
    type?: GraphType;
    title?: string;
}

export class GaugeGraph {
    id?: string;
    graphId: string;
    channels?: GaugeGraphChannel[];
    type?: GraphType;
    title?: string;
}

export class BarGraph {
    id?: string;
    graphId: string;
    displayType: AxisMeasuringRange;
    divisions: number;
    channels?: BarGraphChannel[];
    type?: GraphType;
    title?: string;
}

export interface ExhaustChannel {
    tempChannel: Channel;
    deviationChannel: Channel;
}

export interface Turbocharger {
    tempChannel: Channel;
}

export interface GaugeGraphChannel {
    channel: Channel;
    scaleDivision: number;
    rowNumber?: number;
}
export interface BarGraphChannel {
    channel: Channel;
    barLabel: string;
}

export enum GraphType {
    undefined = 'undefined',
    Gauge = 'ANALOG_METER',
    Bar = 'BAR_GRAPH',
    Exhaust = 'EXHAUST_GAS',
}

export const GraphTypeTranslate = [
    { type: GraphType.Gauge, translate: 'graph.type.gauge' },
    { type: GraphType.Bar, translate: 'graph.type.bar' },
    { type: GraphType.Exhaust, translate: 'graph.type.exhaust' },
];

export enum AxisMeasuringRange {
    Fixed = 'FIXED_VALUE',
    Relative = 'RELATIVE',
}

export const AxisMeasuringRangeOptions = [
    {
        value: AxisMeasuringRange.Fixed,
        translate: 'graph.bar.table.axis-setting.range-format.fixed-value',
    },
    {
        value: AxisMeasuringRange.Relative,
        translate: 'graph.bar.table.axis-setting.range-format.relative',
    },
];

export function getDefaultScaleDivision(channel: Channel): number {
    const range = channel?.fcuData?.measurableRange;

    if (range?.max != null && range?.min != null) {
        const scale = channel?.fcuData?.scale ?? 1;
        const channelRange = (channel.fcuData.measurableRange.max - channel.fcuData.measurableRange.min) / scale;

        for (let i = 7; i >= 3; i--) {
            const result = channelRange / i;
            const rounded = Number(result.toFixed(1));

            if (Math.abs(result - rounded) < 0.0000001) {
                return i;
            }
        }
    }
    return DEFAULT_GAUGE_SCALE;
}

export const MAX_GRAPHS = 10;
export const MAX_CYLINDER_CHANNELS = 24;
export const MAX_TURBO_CHANNELS = 8;
export const MAX_GAUGE_GRAPH_CHANNELS = 8;
export const MAX_BAR_GRAPH_CHANNELS = 24;
export const MAX_SCALE_DIVISION_VALUE = 11;
export const DEFAULT_GAUGE_SCALE = 6;
